interface ErrorMessage {
  name: string;
  message: string;
}

export default function httpErrorMessage(code: number): ErrorMessage {
  let name = "Error";
  let message = "Higharc has encountered an internal error; a report has been sent to our engineering team.";

  switch (code) {
    case 401:
    case 403: {
      name = "Unauthorized";
      message = "You do not have access to this page.";
      break;
    }
    case 404: {
      name = "Page not found";
      message = "We couldn't find the page you're looking for.";
      break;
    }
    case 429: {
      message = "Request rate limit exceeded; please try again later.";
      break;
    }
    case 500: {
      message = "An error occured on our server.";
      break;
    }
  }

  return { name, message };
}
